export default __webpack_public_path__ + "b67c7f2a45a18f9fc622c840620d35b5.png";